<ng-container *ngIf="user$ | async; let user">
    <!-- Navigation -->
    <fuse-vertical-navigation
        class="bg-gray-900 dark print:hidden"
        [mode]="isScreenSmall ? 'over' : 'side'"
        [name]="'mainNavigation'"
        [navigation]="navigation.default"
        [opened]="!isScreenSmall"
        *ngIf="!hideHeader"
    >
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <div class="flex items-center w-full p-4 pl-6">
                <!-- Logo -->
                <!-- <div class="flex items-center justify-center">
                    <img class="w-8" src="assets/images/logo/dynamicLogo.webp" />
                </div> -->
                <!-- Components -->
                <div class="flex items-center ml-auto">
                    <div class="flex items-center justify-center">
                        <button
                            mat-icon-button
                            [matTooltip]="tooltip || 'Logout'"
                            (click)="logout()"
                        >
                            <mat-icon> exit_to_app </mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <!-- User -->
            <div class="flex flex-col items-center w-full p-4">
                <div class="relative w-24 h-24">
                    <img
                        class="w-full h-full rounded-full"
                        *ngIf="user && user.imageId"
                        [src]="user.imageId.baseUrl + user.imageId.key"
                        alt="User avatar"
                    />
                    <img
                        class="w-full h-full rounded-full"
                        *ngIf="!user || !user.imageId"
                        src="assets/images/avatars/admin.jpg"
                        alt="User avatar"
                    />
                </div>
                <div
                    class="flex flex-col items-center justify-center w-full mt-6"
                >
                    <div
                        class="w-full overflow-hidden font-medium leading-normal text-center whitespace-nowrap overflow-ellipsis"
                    >
                        {{ user.firstName + " " + user.lastName }}
                    </div>
                    <div
                        class="w-full mt-0.5 whitespace-nowrap overflow-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary"
                    >
                        {{ user.email }}
                    </div>
                </div>
            </div>
        </ng-container>
        <!-- Navigation footer hook -->
        <ng-container fuseVerticalNavigationContentFooter>
            <div
                class="flex items-center justify-center h-16 pt-10 pl-2 pr-6 mt-2 mb-4 flex-0 opacity-12"
            >
                <!-- <img class="max-w-36" src="assets/images/logo/icon.png" /> -->
            </div>
        </ng-container>
    </fuse-vertical-navigation>

    <!-- Wrapper -->
    <div class="flex flex-col flex-auto w-full min-w-0">
        <!-- Header -->
        <div
            *ngIf="!hideHeader"
            class="relative flex items-center w-full h-16 px-4 shadow flex-0 md:px-6 z-49 dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
        >
            <!-- Navigation toggle button -->
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')"
            >
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
            <p
                class="text-3xl font-medium"
                *ngIf="breadsCrumb$ | async as breadsCrumb"
            >
                {{ breadsCrumb.at(-1)?.name | truncate: 50 }}
            </p>
            <!-- Components -->
            <div
                class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2"
            >
                <div class="flex items-center mr-4">
                    <div class="flex items-center justify-center">
                        <button
                            mat-icon-button
                            matTooltip="Logout"
                            (click)="logout()"
                        >
                            <mat-icon> exit_to_app </mat-icon>
                        </button>
                    </div>
                </div>
                <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            </div>
        </div>

        <!-- Content -->
        <div class="flex flex-col flex-auto p-2 sm:px-10">
            <app-breadscrumb *ngIf="!hideHeader"></app-breadscrumb>
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
        </div>
    </div>
</ng-container>
